
import { defineComponent, onMounted, computed, ref, popScopeId } from "vue";
import BxLogin from "@/components/auths/Login.vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import PopupLoader from "@/components/modals/popups/PopupLoader.vue";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  name: "signin-page",
  components: {
    BxLogin,
    PopupLoader,
  },
  setup() {
    const sponsorId = ref("");
    const seoId = ref("");
    const route = useRoute();
    onMounted(() => {
      setCurrentPageTitle("เข้าสู่ระบบ");
      if (route.name === "sign-in") {
        seoId.value = route.params.id as string; // store.getters.seoId;
      } else {
        sponsorId.value = route.params.id as string; // store.getters.sponsorId;
      }
      //console.log(route.name);
      //console.log(route.params);
    });
    return {
      sponsorId,
      seoId,
    };
  },
});
